import React from 'react';

import '../css/Screen.css';

class CheatScreen extends React.Component {
  render() {
      return (
          <div className="cheat-screen">
            <div className="hint-border">
              <div className="hint-pad"></div>
            </div>
          </div>
      )
  }
}

export default CheatScreen;
